<template>
  <div class="fill-and-flex" v-if="favourites.length">
    <div class="p-4 last:mb-0 border-b">
      <h2 class="fs-5 text-gray-500">Favourites</h2>
    </div>
    <div class="fill-and-flex overflow-y-scroll">
      <FavouriteItem
        v-for="(favourite, index) in favourites"
        :key="index"
        :favourite="favourite"
      />
    </div>
  </div>
  <div class="p-4 m-auto text-center text-gray-600" v-else>
    No favourites saved
  </div>
</template>

<script>
import { mapState } from "vuex";

import FavouriteItem from "@/views/Home/Favourite/Item";

export default {
  name: "Favourites",
  components: {
    FavouriteItem,
  },
  computed: {
    ...mapState(["favourites"]),
  },
};
</script>
